module.exports = __webpack_public_path__ + "static/media/upload_data_landing_placeholder.32779f64.svg";